import createGetFormError from './selectors/getFormError';
import plain from './structure/plain';

export default createGetFormError(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormError.js
// module id = 574
// module chunks = 0